import { css } from "@emotion/core"
import { theme } from "../constants"

export const primaryBannerStyles = css`
  background: ${theme.gradients.violetPink};
  border-radius: ${theme.radii[3]};
  color: ${theme.colors.text};
  min-height: 57px;
  padding: 0.4rem 1rem;
  font-family: ${theme.fonts.primary};
  ${theme.presets.flexXYCentered};
`

export const secondaryBannerStyles = css`
  background: ${theme.gradients.goldBrown};
  border-radius: ${theme.radii[3]};
  color: ${theme.colors.brown[400]};
  padding: 0.4rem 1rem;
  font-family: ${theme.fonts.primary};
  min-height: 57px;
  ${theme.presets.flexXYCentered};
`

const bannerTypeStyles = {
  primary: primaryBannerStyles,
  secondary: secondaryBannerStyles,
}

export const bannerStyles = (type) => {
  return css`
    margin: 1em 0;
    ${bannerTypeStyles[type]}
  `
}
